import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative min-h-150"
}
const _hoisted_2 = { class: "flex justify-around mt-4" }

import { useToast } from 'vue-toastification';
import { required } from '@vuelidate/validators';
import {
	UiCardDivider,
	UiLoader,
	UiSelect,
	UiButton,
	UiForm,
	useLoading,
	useToggle,
	useForm,
	SelectOptions
} from '@/ui-kit';
import { useTeams } from '@/team';
import { usePhoneNumberDetails } from '../composition';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AttachTeamMemberToPhoneNumberDialog',
  setup(__props, { expose }) {

const { success } = useToast();
const { loading: loadingMembers, toggleLoading } =
	useLoading();
const { teamMembers, attachTeamMember } =
	usePhoneNumberDetails();
const { loadTeam, allItems } = useTeams();
const { isOpened, toggleOpened } = useToggle();
const { onSubmit, resetForm, formData, loading } = useForm(
	{
		teamMember: [] as string[]
	},
	{
		teamMember: {
			required
		}
	}
);

const closeDialog = () => toggleOpened(false);

const teamMemberOptions = computed<SelectOptions>(() => {
	const memberIds = teamMembers.value.map(
		(member) => member.id
	);
	return allItems.value
		.filter((item) => !memberIds.includes(item.id))
		.map((item) => ({
			title: item.name,
			value: item.id
		}));
});

const openDialog = async () => {
	resetForm({ teamMember: [] });
	toggleOpened(true);
};

function getSelectedTeamMember(id: string) {
	return allItems.value.find(
		(item) => item.id.toString() === id.toString()
	);
}

const submit = onSubmit(async () => {
	await Promise.all(
		formData.teamMember.map((member) =>
			attachTeamMember(getSelectedTeamMember(member)!)
		)
	);
	closeDialog();
	success(
		formData.teamMember.length === 1
			? 'Team member was successfully attached to this phone number.'
			: 'Team members were successfully attached to this phone number.'
	);
});

expose({
	openDialog
});

return (_ctx: any,_cache: any) => {
  const _component_ElDialog = _resolveComponent("ElDialog")!

  return (_openBlock(), _createBlock(_component_ElDialog, {
    closeOnClickModal: !_unref(loading),
    closeOnPressEscape: !_unref(loading),
    showClose: !_unref(loading),
    onClosed: closeDialog,
    customClass: "is-confirmation",
    modelValue: _unref(isOpened)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(UiCardDivider), { title: "Choose team member to attach to this phone number" }),
      (_unref(loadingMembers))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(UiLoader), {
              wrapperClass: "text-reverse base",
              loadingText: "Loading team members...",
              theme: "primary"
            })
          ]))
        : (_openBlock(), _createBlock(_unref(UiForm), {
            key: 1,
            onSubmit: _unref(submit)
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(UiSelect), {
                name: "teamMember",
                label: "Team member",
                placeholder: "Select team member",
                modelValue: _unref(formData).teamMember,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).teamMember) = $event)),
                disabled: _unref(loading),
                multiple: "",
                options: _unref(teamMemberOptions)
              }, null, 8, ["modelValue", "disabled", "options"]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(UiButton), {
                  disabled: _unref(loading),
                  type: "button",
                  onClick: closeDialog,
                  theme: "primary-outlined"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancel")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_unref(UiButton), { loading: _unref(loading) }, {
                  default: _withCtx(() => [
                    _createTextVNode("Attach team member")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"]))
    ]),
    _: 1
  }, 8, ["closeOnClickModal", "closeOnPressEscape", "showClose", "modelValue"]))
}
}

})